// extracted by mini-css-extract-plugin
export default {"wrapper":"GybemSTy63SV6PjqjPun","title":"n4iSpOA7E4apiiHQplqG","section":"_jrVhqXgAQ5NfGkG6iV9","text":"bjZMYvPmaHvBEOHMEShz"};